/**
 * PATH: packages/email-hub/src/feature/action-signals/api.ts
 * FILE_ID: EMAILHUB-ACTIONSIGNALS-API-001
 * PURPOSE: I/O seams for ephemeral action signals: explicit clipboard writes
 *          and redacted detector feedback.
 * WHY: Keeps presentational signal components Fast-Refresh safe and prevents
 *      any caller from inventing a second feedback path that could send a code.
 */
import { emailApi } from '../lib/api'

export async function writeCodeToClipboard(code: string): Promise<void> {
  if (!navigator.clipboard?.writeText) {
    throw new Error('Clipboard API unavailable')
  }
  await navigator.clipboard.writeText(code)
}

export async function rejectVerificationSignal(emailId: string): Promise<void> {
  await emailApi(
    `/api/kanban/emails/${encodeURIComponent(emailId)}/action-signals/verification_code/feedback/`,
    {
      method: 'POST',
      body: JSON.stringify({ verdict: 'not_code' }),
      headers: { 'Content-Type': 'application/json' },
    },
  )
}
